// extracted by mini-css-extract-plugin
export default {"heading":"ReportingDetailsCollectionsAddTemplate_heading__Ud1l3","buttonLink":"ReportingDetailsCollectionsAddTemplate_buttonLink__-TUWo"};